import React, {FunctionComponent} from 'react';
import {File} from "../../models/file.model";
import './FileTile.scss';

interface FileTileProps {
    file: File;
}

export const FileTile: FunctionComponent<FileTileProps> = (props) => {
    const {file} = props;

    const isImage = (extension: string) => {
        const imageExtensions = ['.tif', '.tiff', '.bmp', '.jpg', '.jpeg', '.gif', '.png', '.ico'];

        return imageExtensions.some(imageExtension => imageExtension === extension.toLowerCase());
    };

    return (
        <div className='file-tile'>
            <div className="file-preview">
                {
                    isImage(file.extension)
                        ? <img src={file.url} alt={`${file.display_name} preview`}/>
                        : <div className="file-preview-outlet">{file.extension}</div>
                }

            </div>

            <p className='file-name'>{file.display_name}<span className='bold-text'>{file.extension}</span></p>
            <p className='file-size'>{file.size}</p>
        </div>
    );
};